<template>
    <v-page-header title="企业微信账号">
        <template slot="title">
            <slot>企业微信账号</slot>
        </template>
        <template v-if="!isPrivate">
            <lamp-tip
                local-key="mng.wework"
                class="wework-lamptip"
            >
                <div class="lamptip-desc">
                    <p>
                        使用 企业微信相关功能* 前需要完成企业微信账号设置，请确保使用同一企业微信账号进行以下操作：<br>
                        1. 在【企业微信账号】中完成账号绑定和通讯录相关设置<br>
                        2. 在【应用管理】中进行应用安装<br>
                        3. 由于企微政策调整，使用企微应用需确认应用订单，应用订单会通过企微推送给管理员，订单免支付，管理员点击确认即可；若未点击确认，订单在3天后会自动确认
                        <a
                            href="https://open.work.weixin.qq.com/wwopen/common/readDocument/47808"
                            target="_blank"
                        >企微政策调整详情</a>
                        <br>
                        * 企业微信相关功能包括：
                        <a
                            href="https://qidian.qq.com/module/wxservice.html"
                            target="_blank"
                        >微信客服</a>
                        <a
                            href="https://qidian.qq.com/solution/sscindex.html"
                            target="_blank"
                        >企业共享服务中心</a>
                    </p>
                </div>
            </lamp-tip>
        </template>
    </v-page-header>
</template>
<script>
import LampTip from '@/components/lamp-tip';
import { isPrivate } from 'src/config/private';

export default {
    components: {
        LampTip,
    },
    data() {
        return {
            isPrivate,
        };
    },
};
</script>
<s lang="less" scoped>
.lamptip-desc {
    a {
        margin-right: 5px;
    }

    a + a {
        padding-left: 5px;
        border-left: 1px solid #c5ccdb;
    }
}
</s>
